import { render, staticRenderFns } from "./TheAdminNodeAllocation.vue?vue&type=template&id=ab471228&"
import script from "./TheAdminNodeAllocation.vue?vue&type=script&lang=js&"
export * from "./TheAdminNodeAllocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports